let vela = window.vela || {};

vela.wishlist = {
  ID: 'vela_wishlist',
  name: '',
  symbol: '|',
  maximumItems: 20,

  selectors: {
    count: '[data-wishlist-count]',
    button: '.js-btn-wishlist',
    page: '[data-wishlist-page]',
    grid: '[data-wishlist-grid]',
    empty: '.js-wishlist-empty'
  },

  classes: {
    added: 'is-added',
    adding: 'is-adding',
    empty: 'is-empty',
    loading: 'loading',
    hidden: 'd-none'
  },

  strings: {
    title: 'Wishlist',
    add: (vela.strings && vela.strings.add_to_wishlist)
      ? vela.strings.add_to_wishlist
      : 'Add to wishlist',

    remove: (vela.strings && vela.strings.remove_wishlist)
      ? vela.strings.remove_wishlist
      : 'Remove from wishlist'
  },

  products: [],

  init: function () {
    this.updateWishlist();
    this.buttons();
  },

  initPage: async function () {

    const page = document.querySelector(
      this.selectors.page
    );

    const wishlistGrid = document.querySelector(
      this.selectors.grid
    );

    if (!page || !wishlistGrid) return;

    page.classList.add(this.classes.loading);

    wishlistGrid.innerHTML = '';

    const emptyMessage =
      page.querySelector(this.selectors.empty);

    /*
     * EMPTY
     */
    if (!this.products.length) {

      page.classList.add(this.classes.empty);

      if (emptyMessage) {
        emptyMessage.classList.remove(
          this.classes.hidden
        );
      }

      page.classList.remove(
        this.classes.loading
      );

      return;
    }

    /*
     * HAS PRODUCTS
     */

    page.classList.remove(
      this.classes.empty
    );

    if (emptyMessage) {
      emptyMessage.classList.add(
        this.classes.hidden
      );
    }

    /*
     * LOAD EACH PRODUCT
     */

    const promises = this.products.map(
      (handle, index) => {

        const url =
          `${window.Shopify.routes.root}products/${handle}?view=wishlist`;

        return fetch(url)
          .then(response => {

            if (!response.ok) {
              throw new Error(
                `Product not found: ${handle}`
              );
            }

            return response.text();

          })
          .then(html => {

            if (!html) return null;

            const item =
              document.createElement('div');

            item.className = 'col';

            item.innerHTML = html;

            return {
              element: item,
              index: index
            };

          })
          .catch(error => {

            console.error(
              'Wishlist error:',
              error
            );

            return null;

          });
      }
    );

    const results =
      await Promise.all(promises);

    /*
     * KEEP ORIGINAL WISHLIST ORDER
     */

    results
      .filter(Boolean)
      .sort((a, b) => a.index - b.index)
      .forEach(item => {

        wishlistGrid.appendChild(
          item.element
        );

      });

    /*
     * UPDATE BUTTONS
     */

    this.updateWishlist();

    page.classList.remove(
      this.classes.loading
    );
  },

  buttons: function () {

    document.addEventListener(
      'click',
      (event) => {

        const button =
          event.target.closest(
            this.selectors.button
          );

        if (!button) return;

        event.preventDefault();
        event.stopPropagation();

        const handle =
          button.dataset.productHandle;

        if (!handle) return;

        const isAdded =
          button.classList.contains(
            this.classes.added
          );

        this.addLoading(button);

        setTimeout(() => {

          if (isAdded) {

            this.removeItem(handle);

          } else {

            this.addItem(handle);

          }

          this.removeLoading(button);

          this.updateWishlist();

          /*
           * RELOAD WISHLIST PAGE
           */

          if (
            document.querySelector(
              this.selectors.page
            )
          ) {

            this.initPage();

          }

        }, 200);
      }
    );
  },

  addItem: function (item) {

    if (!item) return false;

    const index =
      this.products.indexOf(item);

    if (index !== -1) {
      this.products.splice(index, 1);
    }

    this.products.unshift(item);

    this.products =
      this.products.slice(
        0,
        this.maximumItems
      );

    localStorage.setItem(
      this.ID,
      this.products.join(this.symbol)
    );

    return true;
  },

  removeItem: function (item) {

    if (!item) return false;

    this.products =
      this.products.filter(
        product => product !== item
      );

    localStorage.setItem(
      this.ID,
      this.products.join(this.symbol)
    );

    return true;
  },

  addLoading: function (button) {

    if (!button) return;

    button.classList.add(
      this.classes.adding
    );

    const spinner =
      document.createElement('span');

    spinner.className =
      'spinner-border spinner-border-sm';

    button.appendChild(spinner);
  },

  removeLoading: function (button) {

    if (!button) return;

    button.classList.remove(
      this.classes.adding
    );

    const spinner =
      button.querySelector(
        '.spinner-border'
      );

    if (spinner) {
      spinner.remove();
    }
  },

  updateButton: function (
    button,
    added
  ) {

    if (!button) return;

    const label =
      added
        ? this.strings.remove
        : this.strings.add;

    if (added) {

      button.classList.add(
        this.classes.added
      );

    } else {

      button.classList.remove(
        this.classes.added
      );

    }

    button.setAttribute(
      'title',
      label
    );

    const tooltip =
      button.querySelector(
        '.tooltip-inner'
      );

    if (tooltip) {
      tooltip.innerHTML = label;
    }

    const text =
      button.querySelector('.text');

    if (text) {
      text.innerHTML = label;
    }
  },

  updateWishlist: function () {

    /*
     * UPDATE COUNT
     */

    document.querySelectorAll(
      this.selectors.count
    ).forEach(element => {

      element.innerHTML =
        this.products.length;

    });

    /*
     * UPDATE BUTTON STATUS
     */

    document.querySelectorAll(
      this.selectors.button
    ).forEach(button => {

      const handle =
        button.dataset.productHandle;

      if (!handle) return;

      this.updateButton(
        button,
        this.products.includes(handle)
      );

    });
  }
};


/*
 * LOAD FROM LOCAL STORAGE
 */

const wishlistData =
  localStorage.getItem(
    vela.wishlist.ID
  );

if (wishlistData) {

  vela.wishlist.products =
    wishlistData
      .split(vela.wishlist.symbol)
      .filter(Boolean);

}


/*
 * INITIALIZE
 */

document.addEventListener(
  'DOMContentLoaded',
  function () {

    vela.wishlist.init();

    vela.wishlist.initPage();

  }
);